import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GraduationCap, ListChecks, ClipboardList, FlaskConical, ArrowRight } from "lucide-react";

export const RESUME_ICONS = { lesson: GraduationCap, quiz: ListChecks, scenario: ClipboardList, lab: FlaskConical };

export default function ResumeCard({ resume }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  if (!resume) return null;
  const Icon = RESUME_ICONS[resume.kind] || GraduationCap;
  const kindLabel = t(`resume.kind.${resume.kind}`, { lesson: "Lesson", quiz: "Quiz", scenario: "Scenario", lab: "Lab lesson" }[resume.kind]);
  return (
    <button type="button" data-testid="resume-card" onClick={() => navigate(resume.path)}
      className="w-full text-left rounded-xl border border-primary/40 bg-primary/10 hover:bg-primary/15 transition-colors p-4 sm:p-5 flex items-center gap-4 mb-6">
      <span className="h-11 w-11 shrink-0 rounded-full bg-primary/20 text-primary grid place-items-center"><Icon size={22} /></span>
      <span className="min-w-0 flex-1">
        <span className="block text-[10px] font-bold uppercase tracking-[0.2em] text-primary">{t("resume.continue", "Continue where you left off")} · {kindLabel}</span>
        <span className="block font-heading font-bold text-white truncate mt-0.5" data-testid="resume-card-title">{resume.title}</span>
        {resume.kind === "quiz" && resume.meta?.qs && (
          <span className="block text-xs text-slate-400 mt-0.5">{t("quiz.questionOf", { n: (resume.meta.idx || 0) + 1, total: resume.meta.qs.length })}</span>
        )}
      </span>
      <ArrowRight size={18} className="text-primary shrink-0" />
    </button>
  );
}
